import type { ReviewPhase } from "./types";

/** Navigation intent when opening a case from calibration (view disagreement, not re-rate). */
export interface ReviewCaseOpenIntent {
  viewSubmitted?: boolean;
  focusPhase?: ReviewPhase;
  focusArtefactId?: string;
  focusCheckId?: string;
}

export function viewSubmittedCaseIntent(detail: {
  phase: ReviewPhase | "artefact";
  check_id: string;
  artifact_id?: string | null;
}): ReviewCaseOpenIntent {
  if (detail.phase === "artefact") {
    return {
      viewSubmitted: true,
      focusArtefactId: detail.artifact_id ?? undefined,
      focusCheckId: detail.check_id,
    };
  }
  return {
    viewSubmitted: true,
    focusPhase: detail.phase,
    focusCheckId: detail.check_id,
  };
}
